import React, { useState } from 'react';
import {Row, Col, List, Avatar, Collapse, Button} from 'antd';
import useGlobal from '../../../store/Store';
import InvoiceLabels from '../../../config/InvoiceLabels.json';
import { isReliableAndNotOnDocument } from '../../../lib/util/status';
import { TestResult} from '../../../types';
import { Label } from '../../../types/label';
import { ResultField } from '../../../types/result';
import { Icon } from '@ant-design/compatible';
import { CustomSider } from '../../../components/layout/CustomSider';
import { SectionTitle } from '../../../components/text/Titles';
import {Link} from "react-router-dom";
import {DatasetFileVersion} from "../../../types/dataset";
const { Panel } = Collapse;

type Props = { testResult: null | TestResult, toFile: () => any, datasetFileVersion: null | DatasetFileVersion};

const ResultSideBar = ({ testResult, toFile, datasetFileVersion}: Props) => {
  const [globalState, globalActions] = useGlobal();
  const [hoveredResultField, setHoveredResultField] = useState<null | ResultField>(null);

  const onLabelValueMouseEnter = (resultField: ResultField, label: Label) => {
    setHoveredResultField(resultField);
    globalActions.setLabelSelected(label);
  };

  const onLabelValueMouseLeave = () => {
    setHoveredResultField(null);
    globalActions.setLabelSelected(null);
  };

  const renderResult = (resultField: ResultField) => {
    const labelDef = InvoiceLabels.find(it => it.name === resultField.name);
    const resultLabel = globalState.labels.find(l => l.id === resultField.id)!;
    const correctionLabel = globalState.labels.find(l => l.id === resultField.id + '1');

    return (
      <List
        itemLayout="horizontal"
        dataSource={[resultField]}
        renderItem={resultField => (
          <List.Item
            onMouseEnter={() => onLabelValueMouseEnter(resultField, resultLabel)}
            onMouseLeave={() => onLabelValueMouseLeave()}
            onClick={() => {}}
            style={{
              cursor: 'pointer',
              padding: '4px 0',
            }}>
            <List.Item.Meta
              avatar={
                <Avatar
                  className={
                    (resultLabel || correctionLabel) && hoveredResultField && resultField.id === hoveredResultField.id
                      ? correctionLabel && !resultLabel.exists
                        ? 'connectLineD'
                        : 'connectLineB'
                      : ''
                  }
                  shape="square"
                  icon={
                    <Icon
                      type={resultField.correct ? 'check' : 'exclamation-circle'}
                      style={{
                        color: resultField.correct ? '#52c41a' : '#fa541c',
                        zIndex: 5000,
                      }}
                    />
                  }
                  style={{
                    backgroundColor: resultField.correct ? '#d9f7be' : '#ffd8bf',
                    cursor: 'pointer',
                  }}
                />
              }
              title={<span>{labelDef ? labelDef.translation : resultLabel?.name || ''}</span>}
              description={renderValue(resultLabel)}
            />
          </List.Item>
        )}
      />
    );
  };

  const renderValue = (label: Label) => {
    const notOnDocument = isReliableAndNotOnDocument(label);
    return (
      <Row>
        <Col span={13}>{!notOnDocument && <span>{label?.sourceValue || label?.word || 'Not found'}</span>}</Col>
      </Row>
    );
  };

  return (
    <CustomSider width={500} border="left" style={{ paddingTop: '1.25rem' }}>
        <Row className="px-5">

        </Row>
      <Row className="px-5">
        <SectionTitle>Results</SectionTitle>
          <Button style={{marginLeft: '15px'}} onClick={toFile}>Go to Document</Button>
          <Link
              style={{marginLeft: '15px'}}
              className="ant-btn ant-btn-secondary ant-btn-md mr-4"
              to={{pathname: datasetFileVersion?.datasetFile.presignedUrl}}
              target="_blank"
              download>
              Download Pdf
          </Link>
      </Row>
      <Row>
        <Col span={24}>
          {testResult && (
            <Collapse
              style={{ backgroundColor: 'white' }}
              expandIconPosition={'right'}
              bordered={false}
              onChange={() => {}}>
              {testResult.resultFields.map(it => {
                const data = [
                  !it.exists
                    ? {
                        id: it.id,
                        left: 'Test result',
                        valid: it.hasCorrection && it.hasCorrection.correct ? true : false,
                        right: `Not found`,
                        color: it.hasCorrection && it.hasCorrection.correct ? '#52c41a' : '#ccc',
                      }
                    : {
                        id: it.id,
                        left: 'Test result',
                        valid: it.hasCorrection ? it.hasCorrection.correct : it.reliable,
                        right: `"${it.positions[0].originalWord || it.positions[0].word}"`,
                        color: it.hasCorrection
                          ? it.hasCorrection.correct
                            ? '#52c41a'
                            : '#fa541c'
                          : it.reliable
                          ? '#52c41a'
                          : '#fa541c',
                      },
                  it.hasCorrection &&
                    !it.hasCorrection.correct && {
                      id: it.id + '1',
                      left: 'Annotation',
                      valid: true,
                      right: `${
                        !it.hasCorrection.correction?.word ? 'Not found' : '"' + it.hasCorrection.correction?.word + '"'
                      }`,
                      color: '#52c41a',
                    },
                ];

                return (
                  <Panel
                    style={{
                      backgroundColor:
                        hoveredResultField && it.id === hoveredResultField.id ? '#e6f7ff' : 'transparent',
                    }}
                    header={renderResult(it)}
                    key={it.name}>
                    <div
                      style={{
                        padding: '0px 24px',
                        backgroundColor:
                          hoveredResultField && it.id === hoveredResultField.id ? '#e6f7ff' : 'transparent',
                      }}>
                      Process
                      <List
                        size={'small'}
                        bordered={false}
                        split={false}
                        itemLayout="horizontal"
                        dataSource={data.filter(Boolean)}
                        renderItem={dataRow =>
                          dataRow && (
                            <List.Item>
                              <List.Item.Meta
                                title={dataRow.left}
                                avatar={
                                  <Avatar
                                    style={{
                                      backgroundColor: 'transparent',
                                    }}
                                    size={'small'}
                                    icon={
                                      <Icon
                                        type={dataRow.valid ? 'check' : 'exclamation-circle'}
                                        style={{
                                          color: dataRow.valid ? '#52c41a' : '#fa541c',
                                        }}
                                      />
                                    }
                                  />
                                }
                                style={{ color: dataRow.color }}
                              />
                              <div style={{ color: dataRow.color }}>{dataRow.right}</div>
                            </List.Item>
                          )
                        }
                      />
                    </div>
                  </Panel>
                );
              })}
            </Collapse>
          )}
        </Col>
      </Row>
    </CustomSider>
  );
};

export default ResultSideBar;
